import { useState } from "react";
import { ImageUpload } from "@/components/ImageUpload";
import { X } from "@phosphor-icons/react";

export function GalleryField({ value = [], onChange, mainImage = "" }) {
  const [adderKey, setAdderKey] = useState(0);
  const add = (url) => {
    if (!url || value.includes(url) || url === mainImage) return;
    onChange([...value, url]);
    setAdderKey((k) => k + 1);
  };
  return (
    <div data-testid="form-gallery">
      <label className="block text-xs font-medium text-[#5C5A56] mb-1.5">Extra photos ({value.length}) — shown in the product page gallery</label>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2">
          {value.map((src, i) => (
            <div key={src} className="relative w-20 h-16 rounded-lg overflow-hidden border border-[#E5E0D8]">
              <img src={src} alt="" className="w-full h-full object-cover" />
              <button type="button" aria-label="Remove photo" data-testid={`form-gallery-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute top-0.5 right-0.5 w-5 h-5 rounded-full bg-white/95 flex items-center justify-center">
                <X size={10} weight="bold" />
              </button>
            </div>
          ))}
        </div>
      )}
      <ImageUpload key={adderKey} value="" onChange={add} testid="form-gallery-upload" />
    </div>
  );
}
